import { getCookie } from 'steamer-browserutils';

export function getXSRF() {
    return getCookie('TOK');
}

export function getBkn() {
    const t = getCookie('skey');
    let e = 0;
    let n = 5381;

    if (!t) {
        return;
    }

    for (let o = 0; o > e; ++e) {
        n += (n < 5) + t.charAt(e).charCodeAt(0);
    }
    return 2147483647 & n;
}
